import { get, post, patch } from "../helpers/config";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export const useFetchOpenPositions = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (model: any) => {
        const response = await get("papertrade/positions/open?userAccountId=" + model.userAccountId + "&siteId=" + model.siteId + "&stockSymbols=" + model.stockSymbols + "&aiScoreRange=" + model.aiScoreRange + "&positionSide=" + model.positionSide + "&startDate=" + model.startDate + "&endDate=" + model.endDate + "&isGuestUser=" + model.isGuestUser);
        return response;
    }, options);
};

export const useFetchClosedPositions = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (model: any) => {
        const response = await get("papertrade/positions/closed?userAccountId=" + model.userAccountId + "&siteId=" + model.siteId + "&stockSymbols=" + model.stockSymbols + "&aiScoreRange=" + model.aiScoreRange + "&positionSide=" + model.positionSide + "&startDate=" + model.startDate + "&endDate=" + model.endDate + "&isGuestUser=" + model.isGuestUser);
        return response;
    }, options);
};

export const useManualOrderOpen = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (param: any) => {
        return await post("papertrade/manual/order", param);
    }, options);
};

export const useManualOrderUpdate = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (param: any) => {
        return await patch("papertrade/manual/order/update", param);
    }, options);
};

export const useManualOrderClosed = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (param: any) => {
        return await patch("papertrade/manual/order/closed", param);
    }, options);
};

export const useManualOrderDelete = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (model: any) => {
        return await patch(`papertrade/manual/order/delete?positionId=${model.positionId}`, false);
    }, options);
};

export const useCloseOrderUpdate = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (param: any) => {
        return await patch("papertrade/close/order/update", param);
    }, options);
};

export const useCloseOrderDelete = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (model: any) => {
        return await patch(`papertrade/close/order/delete?positionId=${model.positionId}`, false);
    }, options);
};

export const useFetchOpenPositionStocks = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("papertrade/open/position/stocks");
    }, options);
};

export const useFetchClosedPositionStocks = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("papertrade/closed/position/stocks");
    }, options);
};